import React, {useEffect, useRef, useState} from 'react';
import {Stack, Typography} from '@mui/material';
import {highlightText} from '../highlightText';
import DocumentMetadata from './DocumentMetadata';

/**
 * Document header with title, metadata, and tags
 */
const DocumentHeader = React.memo(({
                                       docTitle,
                                       effectiveQuery,
                                       score,
                                       onScoreChange,
                                       classificationLevel,
                                       docUrl,
                                       docSource,
                                       sourceScore,
                                       docSourceType,
                                       hasHTML,
                                       viewMode,
                                       onViewModeChange,
                                       loadingHtml,
                                       tags,
                                       createTag,
                                       voteTag,
                                       removeTag,
                                       isVoted,
                                       isPosting,
                                       loadingTagOps,
                                       docId
                                   }) => {
    const [isScrolled, setIsScrolled] = useState(false);
    const containerRef = useRef(null);

    useEffect(() => {
        const container = containerRef.current;
        if (container) {
            // Get the parent of the parent (grandparent)
            let targetElement = container.parentElement?.parentElement;

            // Check if grandparent is actually scrollable, if not, search for scrollable ancestor
            if (targetElement) {
                const computedStyle = window.getComputedStyle(targetElement);
                const isScrollable = computedStyle.overflow === 'auto' ||
                    computedStyle.overflow === 'scroll' ||
                    computedStyle.overflowY === 'auto' ||
                    computedStyle.overflowY === 'scroll';

                // If not scrollable, search for the first scrollable ancestor
                if (!isScrollable || targetElement.scrollHeight <= targetElement.clientHeight) {
                    let current = targetElement.parentElement;
                    while (current && current !== document.body) {
                        const style = window.getComputedStyle(current);
                        const hasOverflow = style.overflow === 'auto' ||
                            style.overflow === 'scroll' ||
                            style.overflowY === 'auto' ||
                            style.overflowY === 'scroll';
                        if (hasOverflow && current.scrollHeight > current.clientHeight) {
                            targetElement = current;
                            break;
                        }
                        current = current.parentElement;
                    }
                }

                const handleScroll = () => {
                    const scrollTop = targetElement.scrollTop;
                    setIsScrolled(scrollTop > 0);
                };

                // Add scroll listener
                targetElement.addEventListener('scroll', handleScroll, {passive: true});

                // Check initial scroll position
                const initialScrollTop = targetElement.scrollTop;
                setIsScrolled(initialScrollTop > 0);

                return () => {
                    targetElement.removeEventListener('scroll', handleScroll);
                };
            }
        }
    }, []);

    return (
        <Stack
            ref={containerRef}
            spacing={isScrolled ? 1 : 2}
            px={4}
            pt={isScrolled ? 2 : 4}
            pb={2}
            bgcolor={'white'}
            sx={{
                position: 'sticky',
                top: 0,
                zIndex: 10,
                boxShadow: isScrolled ? '0 1px 3px rgba(0,0,0,0.15)' : 'none',

                transition: 'all 0.15s ease-in-out'
            }}
        >
            <Typography variant={'h5'} component={'div'}>
                {highlightText(docTitle ?? '', effectiveQuery)}
            </Typography>

            <DocumentMetadata
                score={score}
                onScoreChange={onScoreChange}
                classificationLevel={classificationLevel}
                docUrl={docUrl}
                docSource={docSource}
                sourceScore={sourceScore}
                docSourceType={docSourceType}
                hasHTML={hasHTML}
                viewMode={viewMode}
                onViewModeChange={onViewModeChange}
                loadingHtml={loadingHtml}
                isScrolled={isScrolled}
            />

            {/*<Stack*/}
            {/*    sx={{*/}
            {/*        transition: 'all 0.15s ease-in-out'*/}
            {/*    }}*/}
            {/*>*/}
            {/*    <TagList*/}
            {/*        tags={tags}*/}
            {/*        createTag={createTag}*/}
            {/*        voteTag={voteTag}*/}
            {/*        removeTag={removeTag}*/}
            {/*        isVoted={isVoted}*/}
            {/*        isPosting={isPosting}*/}
            {/*        loadingTagOps={loadingTagOps}*/}
            {/*        docId={docId}*/}
            {/*    />*/}
            {/*</Stack>*/}

        </Stack>
    );
});

export default DocumentHeader;
